"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var xss_1 = require("xss");
function escapeHTML(content) {
    return xss_1.filterXSS(content, {
        onIgnoreTagAttr: function (tag, name, value) {
            if (name === "style" || name === "class") {
                return name + "=\"" + xss_1.escapeAttrValue(value) + "\"";
            }
            if (tag === "a" && name === "href") {
                return "href=\"" + xss_1.escapeAttrValue(value) + "\"";
            }
            return undefined;
        },
    });
}
exports.escapeHTML = escapeHTML;
//# sourceMappingURL=escape.js.map